const reference = value => value === null || value === undefined ? '' : String(value).trim();
const compareReference = (left, right) => {
  const a = reference(left), b = reference(right);
  if (!a || !b) return a ? -1 : b ? 1 : 0;
  return a.localeCompare(b, 'en-GB', { numeric: true, sensitivity: 'base' });
};

// Status does not split a SECE's detailed activities into separate sections.
// Return the original rows in a new array, retaining every finding and status.
export const sortDetailedActivities = (rows = []) => [...rows].sort((a, b) =>
  compareReference(a?.seceRef || a?.seceNo || a?.seceTitle, b?.seceRef || b?.seceNo || b?.seceTitle)
  || compareReference(a?.vaClientRef || a?.vaRef, b?.vaClientRef || b?.vaRef)
);
